// Footer.js
import React from 'react';
import { Box, Typography, Grid, IconButton, Button } from '@mui/material';
import { Facebook, Instagram, Email } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: 'rgba(34, 193, 195, 0.9)', padding: '30px 40px', borderRadius: '20px 20px 0 0', color: '#fff' }}>
      <Typography variant="h6" sx={{ textAlign: 'left', marginBottom: '30px', color: '#000' }}>
        <b>Quick Links</b>
      </Typography>

      <Grid container spacing={6} alignItems="flex-start" justifyContent="space-between">
        {/* Social Links */}
        <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'center', sm: 'left' }, padding: '0 10px' , color: '#000'}}>
          <Typography variant="h6" gutterBottom>
            Social Links
          </Typography>
          <IconButton href="https://www.facebook.com/profile.php?id=61570443219086&mibextid=ZbWKwL" target="_blank" sx={{ color: '#fff' }}>
            <Facebook />
          </IconButton>
          <IconButton href="https://www.instagram.com/jamia_nida_e_islam_school?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" sx={{ color: '#fff' }}>
            <Instagram />
          </IconButton>
          <IconButton href="mailto:jniinst786@gmail.com" sx={{ color: '#fff' }}>
            <Email />
          </IconButton>
        </Grid>

        {/* Contact Us */}
        <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'center', sm: 'left' }, padding: '0 10px', color: '#000' }}>
          <Typography variant="h6" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="body2" sx={{ display: 'block', color: '#fff', marginBottom: '5px', color: '#000' }}>
            Email: <a href="mailto:jniinst786@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>jniinst786@gmail.com</a>
          </Typography>
          <Typography variant="body2" sx={{ display: 'block',  color: '#000' }}>
          Phone 1: <a href="tel:+919005084268" style={{ color: 'inherit', textDecoration: 'none' }}>+919005084268</a>
          <br/>Phone 2: <a href="tel:+915324072008" style={{ color: 'inherit', textDecoration: 'none' }}>+915324072008</a>
          </Typography>
        </Grid>
        {/* Reach Us */}
        <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'center', sm: 'left' }, padding: '0 10px' , color: '#000'}}>
          <Typography variant="h6" gutterBottom>
            Reach Us
          </Typography>
          <Typography variant="body2" sx={{ color: '#000'}}>
            <a href="/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
            J.K Ashiyana, Kareli, Prayagraj <br/> Uttar Pradesh
            </a>
          </Typography>
        </Grid>
      </Grid>

      {/* Donate Us Section */}
      <Box sx={{ textAlign: 'center', marginTop: '30px', padding: '20px', backgroundColor: 'rgba(247, 130, 126, 0.8)', borderRadius: '10px' }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#000' }}>
          Donate Us
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '20px', color: '#000' }}>
          Your generous contributions help us make a difference. Support our mission today!
        </Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#fff', color: 'rgba(34, 193, 195, 0.9)', fontWeight: 'bold', borderRadius: '20px', padding: '10px 20px' }}
          href="#"
        >
          Donate Now
        </Button>
      </Box>
    </Box>
  );
};

export default Footer;
